export default __webpack_public_path__ + "static/media/pac-shark-home.4cec60f7.png";